import { Component, AfterViewInit, ChangeDetectorRef  } from '@angular/core';
import { TerminalsService } from '../../services/terminals.service';

@Component({
    selector: 'terminals',
    templateUrl: './terminals.component.html',
    styleUrls: ['./terminals.component.scss'],
    standalone: false
})
export class TerminalsComponent implements AfterViewInit {

  constructor(public terminalsService: TerminalsService, private cdr: ChangeDetectorRef) {

  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  public get isBackdropOkay(): boolean {
    return this.terminalsService.isBackdropOkay();
  }

  public get isTerminalsListVisible(): boolean {
    return this.terminalsService.isListVisible;
  }

  public get isTerminalSelected(): boolean {
    return this.terminalsService.isModelSelected();
  }

  public changeTerminalListVisible(value: boolean) {
    this.terminalsService.isListVisible = value;
  }

}
